export default __webpack_public_path__ + "static/media/my health.eb966ee5.svg";